import React from 'react'

const CreditAnalysis = () => {
    const cardsData = [
      { label: "Total borrowed", value: "500, 890 NGN" },
      { label: "Total defaults", value: "45,680 NGN" },
      { label: "Total outstanding", value: "45,680 NGN" },
      { label: "Highest loan amount", value: "45,680 NGN" },
      { label: "Total credit account", value: "7" },
      { label: "Total watchlisted account", value: "2" },
      { label: "Total lost account", value: "1" },
    ];
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {cardsData.map((card, index) => (
        <div
          key={index}
          className="bg-[#F5F5FF] rounded-md border border-[#DFE0F3] shadow-sm text-sm p-4 "
        >
          <h3 className="text-[#616161] font-medium mb-2">{card.label}</h3>
          <p className="text-md ">{card.value}</p>
        </div>
      ))}
    </div>
  );
}

export default CreditAnalysis